import React from 'react';
import { Alert, Button } from '@mui/material';
import { isStoreDistribution, isStoreSafeModeEnabled, getShellVersion } from '../../utils/distribution';

const StoreSafeModeBanner: React.FC = () => {
  if (!isStoreDistribution() || !isStoreSafeModeEnabled()) {
    return null;
  }

  const shellVersion = getShellVersion() ?? 'unknown';

  return (
    <Alert
      severity="warning"
      sx={{ borderRadius: 0 }}
      action={
        <Button color="inherit" size="small" onClick={() => window.location.reload()}>
          Retry
        </Button>
      }
    >
      This app version ({shellVersion}) is no longer supported. Update Qixit Mail from the app store, then reopen.
    </Alert>
  );
};

export default StoreSafeModeBanner;
